<template>
<div class="page-title">
  甲醇燃料电池汽车运行状况AI诊断仿真平台
  <div class="right-btn" v-if="$route.path != '/index'" @click="goHome">返回首页</div>
</div>
</template>

<script>

export default {
  name: "Navbar",
  data() {
    return {}
  },
  computed: {
    user() {
      return this.$store.state.auth.user
    },
  },
  created() {
  },
  mounted() {

  },
  methods: {
    goHome() {
      if (this.$route.path != '/index') {
        this.$router.push('/index')
      }
    },
    // logout() {
    //   let that = this
    //   that.$store.dispatch('auth/logout').then(() => {
    //     that.$router.replace('/login')
    //   })
    // },
  },
}
</script>

<style lang="scss" scoped>
$pageColor: #17A6BF;
$pageColorBlack: #2F3133;
.page-title {
  position: relative;
  height: 80px;
  width: 100vw;
  background: $pageColor;
  font-size: 32px;
  font-weight: 500;
  padding: 20px;
  color: #fff;
  text-align: center;
  caret-color: transparent;

  .right-btn {
    //width: 88px;
    height: 32px;
    padding: 0 10px;
    position: absolute;
    right: 80px;
    top: 24px;
    z-index: 10;
    border: 1px solid #fff;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    border-radius: 4px;
    line-height: 30px;
    cursor: pointer;

  }
}
</style>
